var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoOfekAr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76.827,
    height: 33.132,
    viewBox: "0 0 76.827 33.132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2769",
    "data-name": "Rectangle 2769",
    width: 76.827,
    height: 33.132,
    transform: "translate(0 0)",
    fill: "#c5c5c8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5254",
    "data-name": "Group 5254",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4527",
    "data-name": "Path 4527",
    d: "M99.659,21.267a2.236,2.236,0,0,1-2.394,2.027H76.348a2.039,2.039,0,1,1,0-4.054H97.265a2.236,2.236,0,0,1,2.394,2.027",
    transform: "translate(-22.832 -5.929)",
    fill: "#c5c5c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2766",
    "data-name": "Rectangle 2766",
    width: 4.054,
    height: 4.053,
    rx: 2.026,
    transform: "translate(68.873 5.874)",
    fill: "#c5c5c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2767",
    "data-name": "Rectangle 2767",
    d: "M2.026,0h0A2.026,2.026,0,0,1,4.054,2.026v0A2.027,2.027,0,0,1,2.027,4.053h0A2.026,2.026,0,0,1,0,2.027v0A2.026,2.026,0,0,1,2.026,0Z",
    transform: "translate(34.584 5.874)",
    fill: "#c5c5c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4528",
    "data-name": "Path 4528",
    d: "M22.645,10.465a1.977,1.977,0,0,0-1.974-1.974h-.106a1.978,1.978,0,0,0-1.974,1.974v.105a1.976,1.976,0,0,0,1.974,1.974h.105a1.977,1.977,0,0,0,1.974-1.974Z",
    transform: "translate(-5.729 -2.617)",
    fill: "#c5c5c8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4529",
    "data-name": "Path 4529",
    d: "M14.139,10.465a1.977,1.977,0,0,0-1.974-1.974H12.06a1.978,1.978,0,0,0-1.974,1.974v.105a1.976,1.976,0,0,0,1.974,1.974h.105a1.977,1.977,0,0,0,1.974-1.974Z",
    transform: "translate(-3.108 -2.617)",
    fill: "#c5c5c8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4530",
    "data-name": "Path 4530",
    d: "M91.765,10.517a2.038,2.038,0,0,1-2.044,2.027H81.655a1.958,1.958,0,0,1-1.926-2.027A1.958,1.958,0,0,1,81.655,8.49h8.065a2.038,2.038,0,0,1,2.044,2.027",
    transform: "translate(-24.569 -2.616)",
    fill: "#c5c5c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2768",
    "data-name": "Rectangle 2768",
    width: 4.054,
    height: 4.053,
    rx: 2.026,
    transform: "translate(55.16 20.749)",
    fill: "#c5c5c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4531",
    "data-name": "Path 4531",
    d: "M88.012,32.017a2.038,2.038,0,0,0,2.044,2.027h8.065a2.03,2.03,0,0,0,0-4.054H90.056a2.038,2.038,0,0,0-2.044,2.027",
    transform: "translate(-27.122 -9.242)",
    fill: "#c5c5c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4532",
    "data-name": "Path 4532",
    d: "M8.955,39.134a12.556,12.556,0,0,1-3.878-.547A8,8,0,0,1,2.27,37.053,6.369,6.369,0,0,1,.57,34.7a7.754,7.754,0,0,1-.57-3,8.11,8.11,0,0,1,.134-1.427l.04-.226c.208-1.192.493-2.824,1.943-2.959.06-.006.119-.008.178-.008a3.85,3.85,0,0,1,1.117.223l.046.014c.866.264.65,1.483.509,2.289-.028.16-.054.3-.066.418a6.78,6.78,0,0,0,.178,3.266,3.962,3.962,0,0,0,1.01,1.484,4.769,4.769,0,0,0,1.685.975,7.214,7.214,0,0,0,2.361.353,8.252,8.252,0,0,0,2.379-.334,5.289,5.289,0,0,0,1.9-1.009,4.775,4.775,0,0,0,1.261-1.7,5.775,5.775,0,0,0,.461-2.3,6.06,6.06,0,0,1-1.075.2c-.394.036-.746.054-1.047.054a7.293,7.293,0,0,1-2.862-.5,5.561,5.561,0,0,1-1.918-1.306,4.978,4.978,0,0,1-1.078-1.806,6.265,6.265,0,0,1-.336-2,6.067,6.067,0,0,1,.444-2.318,5.512,5.512,0,0,1,1.274-1.885,5.975,5.975,0,0,1,2-1.257,7.245,7.245,0,0,1,2.624-.456,7.558,7.558,0,0,1,1.234.107,5.238,5.238,0,0,1,1.267.383,5.011,5.011,0,0,1,1.182.749,4.608,4.608,0,0,1,.987,1.195,6.492,6.492,0,0,1,.672,1.712,9.535,9.535,0,0,1,.248,2.3v3.867a10.252,10.252,0,0,1-.749,4.048,8.21,8.21,0,0,1-2.07,2.931,8.792,8.792,0,0,1-3.113,1.773,12.29,12.29,0,0,1-3.871.594m3.768-16.727a2.1,2.1,0,0,0-.909.2,2.211,2.211,0,0,0-.739.572,2.858,2.858,0,0,0-.5.891,3.391,3.391,0,0,0-.187,1.153,3.214,3.214,0,0,0,.167,1.036,2.223,2.223,0,0,0,.529.858,2.6,2.6,0,0,0,.935.587,3.891,3.891,0,0,0,1.379.219,4.785,4.785,0,0,0,.488-.026q.255-.026.5-.066t.457-.091a2.174,2.174,0,0,0,.3-.091v-.959a9.168,9.168,0,0,0-.215-2.191,3.881,3.881,0,0,0-.556-1.3,1.719,1.719,0,0,0-.762-.623,2.473,2.473,0,0,0-.882-.166",
    transform: "translate(0 -6.001)",
    fill: "#c5c5c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4533",
    "data-name": "Path 4533",
    d: "M37.65,30.933a3.586,3.586,0,0,1-.543-.035.761.761,0,0,1-.381-.158.667.667,0,0,1-.207-.349,2.241,2.241,0,0,1-.056-.566V28.9a2.521,2.521,0,0,1,.034-.446.637.637,0,0,1,.53-.54,2.79,2.79,0,0,1,.623-.055h3.912a5.259,5.259,0,0,1-.447-1.119A5.565,5.565,0,0,1,40.9,25.2a5.7,5.7,0,0,1,1.731-4.137,5.971,5.971,0,0,1,1.938-1.237,7,7,0,0,1,4.772-.06,4.75,4.75,0,0,1,1.75,1.134,5.039,5.039,0,0,1,1.1,1.813,7.14,7.14,0,0,1,.383,2.408v5.81ZM46.7,22.377a2.1,2.1,0,0,0-.909.2,2.235,2.235,0,0,0-.739.567,2.826,2.826,0,0,0-.5.873,3.266,3.266,0,0,0-.186,1.128,2.9,2.9,0,0,0,.2,1.106,2.457,2.457,0,0,0,.582.857,2.558,2.558,0,0,0,.922.551,3.768,3.768,0,0,0,1.249.194h1.633v-2.19a5.533,5.533,0,0,0-.2-1.59,2.919,2.919,0,0,0-.506-1.009,1.767,1.767,0,0,0-.713-.531,2.32,2.32,0,0,0-.842-.159",
    transform: "translate(-11.236 -5.972)",
    fill: "#c5c5c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4534",
    "data-name": "Path 4534",
    d: "M65.973,27.475A2.247,2.247,0,0,1,64.1,24.992V10.312a1.923,1.923,0,1,1,3.752,0v14.68a2.247,2.247,0,0,1-1.876,2.483",
    transform: "translate(-19.752 -2.455)",
    fill: "#c5c5c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4535",
    "data-name": "Path 4535",
    d: "M35.649,27.238a5.19,5.19,0,0,1-1.934-.324A3.494,3.494,0,0,1,32.385,26a3.687,3.687,0,0,1-.767-1.425,6.485,6.485,0,0,1-.242-1.819L31.248,9.735A2.127,2.127,0,0,1,33.124,7.39,2.127,2.127,0,0,1,35,9.735l0,12.29a4.924,4.924,0,0,0,.1,1.072,1.688,1.688,0,0,0,.275.648.921.921,0,0,0,.448.321,2.123,2.123,0,0,0,.668.095h.649c.092,0,9.253.012,9.4.043l.071.015v2.971l-.074.012c-.008,0-.008,0-4.45,0H37.65a3.215,3.215,0,0,1-.517.033Z",
    transform: "translate(-9.629 -2.277)",
    fill: "#c5c5c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4536",
    "data-name": "Path 4536",
    d: "M67.592,4.066a4.147,4.147,0,0,1-.7-.077,7.185,7.185,0,0,1-.708-.181,9.657,9.657,0,0,1-1.232-.514,5.408,5.408,0,0,0-2.143-.679h-.053a1.377,1.377,0,0,0-.585.191,3.452,3.452,0,0,1-.336.152,1.431,1.431,0,0,1-.489.094,1.068,1.068,0,0,1-.838-.406,1.151,1.151,0,0,1-.289-1.018A2.276,2.276,0,0,1,61.551.28,3.4,3.4,0,0,1,62.938,0a3.931,3.931,0,0,1,.812.084A7.83,7.83,0,0,1,66.017.91c.85.5,1.979,1,2.474-.143A.725.725,0,0,1,69.2.3a1.6,1.6,0,0,1,1.468.934A1.576,1.576,0,0,1,70.5,2.459a3.448,3.448,0,0,1-.658.87,2.527,2.527,0,0,1-.945.555,3.835,3.835,0,0,1-1.2.183Z",
    transform: "translate(-18.549 0)",
    fill: "#c5c5c8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOfekAr);
export default __webpack_public_path__ + "static/media/LogoOfek_ar.e5780f987a217c147cdf21c9f3fda1d2.svg";
export { ForwardRef as ReactComponent };